module.exports = __webpack_public_path__ + "img/g0003.f21fc36c.png";